import type { CellContext } from '@tanstack/react-table';
import { useContext } from 'react';
import Badge from '@/components/UI/Badge';
import ReactSelect from '@/components/UI/Form/ReactSelect';
import { TableRowContext } from '@/features/ChangeOrder/Summary/Table/TableRowContext';
import type { ColMeta } from '@/features/ChangeOrder/Summary/Table/types';
import { convertEnumToText } from '@/utils';

export function EditableStatus({ column, cell }: CellContext<any, any>) {
  const columnMeta = column.columnDef.meta as ColMeta | undefined;
  const { editedRow, setEditedRow, isEditing } = useContext(TableRowContext);
  const currentValue = editedRow?.[column.id] || cell.getValue() || null;

  const onSelectChange = (newValue: unknown) => {
    setEditedRow((prevState) => ({
      ...prevState,
      [column.id]: newValue,
    }));
  };

  if (isEditing) {
    return <ReactSelect options={columnMeta?.options} onChange={onSelectChange} value={currentValue} />;
  }
  return <Badge status={currentValue} text={currentValue ? convertEnumToText(currentValue) : ''} />;
}
